Shopify.personalisation = function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', Shopify.personalisation);
    return;
  }

  if (window._personalisationInit) return;
  window._personalisationInit = true;

  const elements = {
    customizationProduct: document.querySelector('.customization_product'),
    paymentButton: document.querySelector('[data-shopify="payment-button"]'),
    addToCartButton: document.querySelector('.add-to-cart[type="submit"]')
  };

  if (!elements.customizationProduct && elements.paymentButton) {
    elements.paymentButton.remove();
  }

  let forceShowErrors = false;

  const updateButtonState = (disabled, reason = '') => {
    const button = elements.addToCartButton || document.querySelector('.add-to-cart[type="submit"]');
    if (button) {
      button.disabled = disabled;
      button.dataset.disableReason = reason;
    }
  };

  const validateAll = () => {
    let invalid = false;

    document.querySelectorAll('.product_properties').forEach(block => {
      const yes = block.querySelector('.btn-radio__checked[value="yes"]:checked');
      const error = block.querySelector('.properties_custom__error');
      const input = block.querySelector('.properties_custom input');

      if (!yes || !input) {
        if (error) error.style.display = 'none';
        if (input) input.style.borderColor = '';
        return;
      }

      const empty = !input.value.trim();
      const showError = empty && (forceShowErrors || input.dataset.touched === 'true');

      if (error) error.style.display = showError ? 'block' : 'none';
      input.style.borderColor = showError ? '#d72c0d' : '';
      if (empty) invalid = true;
    });

    updateButtonState(invalid, invalid ? 'input-validation' : 'input-valid');
  };

  const handleChecked = (el) => {
    if (!el) return;

    const isNoOption = el.value === 'no';
    const layoutInput = el.closest('.layoutInput');
    if (!layoutInput) return;

    const noCustomInput = layoutInput.querySelector('.noCustom');
    const propertiesInputs = layoutInput.querySelectorAll('.properties_custom input');
    const propertiesDiv = layoutInput.querySelector('.properties_custom');
    const errorElement = layoutInput.querySelector('.properties_custom__error');

    if (isNoOption) {
      if (noCustomInput) {
        noCustomInput.value = 'Customer requires no text';
        noCustomInput.removeAttribute('disabled');
      }
      propertiesInputs.forEach(input => {
        input.setAttribute('disabled', 'disabled');
        input.dataset.touched = 'false';
        input.style.borderColor = '';
      });
      if (propertiesDiv) propertiesDiv.style.display = 'none';
      if (errorElement) errorElement.style.display = 'none';
    } else {
      if (noCustomInput) {
        noCustomInput.setAttribute('disabled', 'disabled');
        noCustomInput.value = '';
      }
      propertiesInputs.forEach(input => {
        input.removeAttribute('disabled');
        input.dataset.touched = 'false';
        input.style.borderColor = '';
      });
      if (propertiesDiv) propertiesDiv.style.display = 'block';
      if (errorElement) errorElement.style.display = 'none';
    }

    validateAll();
  };

  document.querySelectorAll('.btn-radio__checked:checked').forEach(handleChecked);
  validateAll();

  document.addEventListener('input', (event) => {
    if (event.target.closest && event.target.closest('.properties_custom')) validateAll();
  }, true);

  document.addEventListener('blur', (event) => {
    const target = event.target;
    if (target && target.closest && target.closest('.properties_custom') && target.tagName === 'INPUT') {
      target.dataset.touched = 'true';
      validateAll();
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.classList && event.target.classList.contains('btn-radio__checked')) {
      handleChecked(event.target);
    }
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.querySelector) return;
    if (event.target.querySelector('.add-to-cart[type="submit"]') || document.querySelector('.customization_product')) {
      forceShowErrors = true;
      validateAll();
    }
  }, true);
};

Shopify.checkInputEmpty = function() {
  const context = document.querySelector('.sf-modal__wrapper') ? '.sf-modal__wrapper' : '';
  const checkedRadios = document.querySelectorAll(context + ' .btn-radio__checked:checked');

  for (const radio of checkedRadios) {
    if (radio.value === 'yes') {
      const layoutInput = radio.closest('.layoutInput');
      const customInput = layoutInput?.querySelector('.properties_custom input');
      if (customInput && customInput.value.trim() === '') {
        const button = document.querySelector(context + ' .add-to-cart[type="submit"]');
        if (button) button.disabled = true;
        break;
      }
    }
  }
};

;(function() {
  let retryCount = 0;
  const maxRetries = 10;

  const initPersonalisation = () => {
    if (typeof Shopify?.personalisation === 'function') {
      try {
        window._personalisationInit = false;
        Shopify.personalisation();
      } catch (e) {
        console.warn('Personalisation init failed:', e);
      }
    } else if (retryCount < maxRetries) {
      retryCount++;
      setTimeout(initPersonalisation, 100);
    }
  };

  const setupQuickview = () => {
    if (window.MinimogTheme?.ProductQuickView?.modal) {
      const originalOpen = window.MinimogTheme.ProductQuickView.modal.open;
      window.MinimogTheme.ProductQuickView.modal.open = function() {
        originalOpen.call(this);
        setTimeout(() => {
          retryCount = 0;
          initPersonalisation();
        }, 150);
      };
    } else {
      setTimeout(setupQuickview, 500);
    }
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('.sf-pqv__button')) {
      retryCount = 0;
      setTimeout(initPersonalisation, 400);
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 &&
            (node.classList?.contains('sf-modal__wrapper') ||
             node.querySelector?.('.sf-modal__wrapper'))) {
          setTimeout(() => {
            retryCount = 0;
            initPersonalisation();
          }, 200);
        }
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupQuickview();
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    setupQuickview();
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', Shopify.personalisation);
} else {
  Shopify.personalisation();
}